/* Moments Theme v5.1.0 — progressive theme-wide enhancements */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const updateScrollState = () => {
    document.body.classList.toggle('me-has-scrolled', window.scrollY > 12);
  };

  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });

  if (reduceMotion || !('IntersectionObserver' in window)) return;

  const selectors = [
    '.me-collections-header', '.me-collection-card',
    '.me-why__header', '.me-why__card',
    '.me-featured-products__header', '.me-featured-product-card',
    '.me-creations__header', '.me-creation-card',
    '.me-wedding-showcase__content', '.me-wedding-showcase__media',
    '.me-business-showcase__content', '.me-business-showcase__media',
    '.me-story__content', '.me-story__media',
    '.me-final-cta__inner', '.me-pc-product-card'
  ];

  const elements = document.querySelectorAll(selectors.join(','));
  if (!elements.length) return;

  document.documentElement.classList.add('me-motion-ready');
  elements.forEach((element, index) => {
    element.dataset.meReveal = '';
    element.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -45px' });

  elements.forEach((element) => observer.observe(element));
})();
